import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Summary } from "./SubmitStep";

export default function SharedJourney() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [cat, setCat] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/journey/shared/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
    api.get("/journey/catalog").then((r) => setCat(r.data));
  }, [token]);
  const pdf = async () => { const r = await api.get(`/journey/shared/${token}/pdf`, { responseType: "blob" }); Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: "requested-itinerary-pending-review.pdf" }).click(); };
  if (err) return <div className="container-x py-24 text-center text-slate-600" data-testid="shared-journey-error">{err}</div>;
  if (!d || !cat) return <div className="container-x py-24 text-slate-500">Loading…</div>;
  return (
    <div className="container-x max-w-3xl py-12" data-testid="shared-journey">
      <p className="eyebrow">Shared with you · view only</p>
      <h1 className="font-display text-4xl font-semibold">A Holy Land journey in the making</h1>
      <p className="mt-2 text-sm text-slate-600">Requested Itinerary — Pending Review. This is not a booking or a confirmed schedule.</p>
      <button className="btn-outline btn-sm my-4" onClick={pdf} data-testid="shared-pdf-btn"><Download className="h-3 w-3" />Download PDF</button>
      <Summary state={d.state} cat={cat} warnings={d.state.warnings || []} />
    </div>
  );
}
